import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components/index";

/**
 *  @property {Tickets_Checklist_Object} state
 *  @property {object} model
 *  @property {Tickets_Checklist_Properties} model.properties
 *  @property {Tickets_Checklist_Is} model.is
 *  @property {Tickets_Checklist_Has} model.has

 */
export default class TicketCheckList extends Framework.Components.Object {

	constructor(props) {
		super(props,Types.Tickets_Checklist._name);
		this.redirect = this.props.baseUrl;	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	form = () =>{
		/**
		 * @param {Tickets_Checklist_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Tickets_Checklist_Object} object
		 */
		let object = this.state
		let{loading}= this.state

		return (
				<div>
					<fieldset >
						<div className={"row"}>
							<div className={"col-md"}>
								<h4 className="section-title">Wireless Network Check </h4>

								<div className="form-group">
									<Framework.Elements.TextField
										label={"Make Model of Router or AP"}
										value={object.make_ap}
										error={object.make_ap_error}
										property={properties.make_ap}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"WiFi Router or AP Age"}
										value={object.ap_age}
										error={object.ap_age_error}
										property={properties.ap_age}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"SSID"}
										value={object.ssid}
										error={object.ssid_error}
										property={properties.ssid}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Guest Network"}
										value={object.guest_network}
										error={object.guest_network_error}
										property={properties.guest_network}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"WiFi Channel"}
										value={object.wifi_channel}
										error={object.wifi_channel_error}
										property={properties.wifi_channel}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<div className={"row"}>
										<div className={"col-6"}>
											<span className="input-label">Patched for Krack Vulnerability?</span>
										</div>
										<div className={"col-6 text-right"}>
											<Framework.Elements.ButtonSwitch
												value={object.patch_krack}
												error={object.patch_krack_error}
												property={properties.patch_krack}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"Yes"}
												labelFalse={"No"}
											/>
										</div>
									</div>
								</div>
								<div className="form-group">
									<div className={"row"}>
										<div className={"col-6"}>
											<span className="input-label">GHZ Setup</span>
										</div>
										<div className={"col-6 text-right"}>
											<Framework.Elements.ButtonSwitch
												value={object.ghz_setup}
												error={object.ghz_setup_error}
												property={properties.ghz_setup}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"Yes"}
												labelFalse={"No"}
											/>
										</div>
									</div>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"How many devices are on the network?"}
										value={object.device_amount}
										error={object.device_amount_error}
										property={properties.device_amount}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Short Network Survey"}
										value={object.short_network_survey}
										error={object.short_network_survey_error}
										property={properties.short_network_survey}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-md"}>
								<h4 className="section-title">Anti-Virus Check </h4>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Brand of Antivirus"}
										value={object.antivirus_brand}
										error={object.antivirus_brand_error}
										property={properties.antivirus_brand}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<div className={"row"}>
										<div className={"col-6"}>
											<span className="input-label">Up to date?</span>
										</div>
										<div className={"col-6 text-right"}>
											<Framework.Elements.ButtonSwitch
												value={object.up_to_date}
												error={object.up_to_date_error}
												property={properties.up_to_date}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"Yes"}
												labelFalse={"No"}
											/>
										</div>
									</div>
								</div>
								<div className="form-group">
									<Framework.Elements.Date
										label={"Last scan"}
										value={object.last_scan}
										error={object.last_scan_error}
										property={properties.last_scan}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<div className={"row"}>
										<div className={"col-6"}>
											<span className="input-label">ISCA certified?</span>
										</div>
										<div className={"col-6 text-right"}>
											<Framework.Elements.ButtonSwitch
												value={object.isca}
												error={object.isca_error}
												property={properties.isca}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"Yes"}
												labelFalse={"No"}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className={"col-md"}>

								<h4 className="section-title">Stability Check </h4>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"System Log Warnings"}
										value={object.system_warnings}
										error={object.system_warnings_error}
										property={properties.system_warnings}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"System Log Errors"}
										value={object.system_errors}
										error={object.system_errors_error}
										property={properties.system_errors}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.DateTime
										label={"Last Crash"}
										value={object.last_crash}
										error={object.last_crash_error}
										property={properties.last_crash}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.DateTime
										label={"Last Reboot"}
										value={object.last_reboot}
										error={object.last_reboot_error}
										property={properties.last_reboot}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

							</div>
							<div className={"col-md"}>
								<h4 className="section-title">Backup Check </h4>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Local backup type"}
										value={object.local_backup}
										error={object.local_backup_error}
										property={properties.local_backup}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Backup Method Used?"}
										value={object.backup_method}
										error={object.backup_method_error}
										property={properties.backup_method}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.DateTime
										label={"Last local backup"}
										value={object.last_local_backup}
										error={object.last_local_backup_error}
										property={properties.last_local_backup}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Total Local Backup Size"}
										value={object.local_backup_size}
										error={object.local_backup_size_error}
										property={properties.local_backup_size}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Offsite Backup"}
										value={object.offsite_backup}
										error={object.offsite_backup_error}
										property={properties.offsite_backup}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.DateTime
										label={"Last Offsite Backup"}
										value={object.last_offsite_backup}
										error={object.last_offsite_backup_error}
										property={properties.last_offsite_backup}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Total Offsite Backup Size"}
										value={object.offsite_backup_size}
										error={object.offsite_backup_size_error}
										property={properties.offsite_backup_size}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>

							</div>


						</div>
					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title"> Hard Drive Health </h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"SMART Errors"}
									value={object.smart_errors}
									error={object.smart_errors_error}
									property={properties.smart_errors}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"POH (Hours on)"}
									value={object.poh}
									error={object.poh_error}
									property={properties.poh}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Relocated Sector Count"}
									value={object.sector_count}
									error={object.sector_count_error}
									property={properties.sector_count}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Pending Failure SMART Values"}
									value={object.failure_smart_values}
									error={object.failure_smart_values_error}
									property={properties.failure_smart_values}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Fragmentation Level"}
									value={object.frag_lvl}
									error={object.frag_lvl_error}
									property={properties.frag_lvl}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Drive Speed"}
									value={object.drive_speed}
									error={object.drive_speed_error}
									property={properties.drive_speed}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Manufacturer"}
									value={object.manufacturer}
									error={object.manufacturer_error}
									property={properties.manufacturer}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

						</div>
						<div className={"col-md"}>
							<h4 className="section-title">System Temperature Health </h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"CPU Temperature"}
									value={object.cpu_temp}
									error={object.cpu_temp_error}
									property={properties.cpu_temp}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Is CPU within manufacturer range?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.cpu_in_range}
											error={object.cpu_in_range_error}
											property={properties.cpu_in_range}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"MB Temperature"}
									value={object.mb_temp}
									error={object.mb_temp_error}
									property={properties.mb_temp}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"GPU Temperature"}
									value={object.gpu_temp}
									error={object.gpu_temp_error}
									property={properties.gpu_temp}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"HD Temperature"}
									value={object.hd_temp}
									error={object.hd_temp_error}
									property={properties.hd_temp}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Are all temperatures within safe range?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.temp_safe_range}
											error={object.temp_safe_range_error}
											property={properties.temp_safe_range}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Recommended New Fans?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.rec_new_fans}
											error={object.rec_new_fans_error}
											property={properties.rec_new_fans}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Temperatures good under stress test?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.temp_under_stress}
											error={object.temp_under_stress_error}
											property={properties.temp_under_stress}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>

						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Clean Out Check </h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Anti-Malware Scan Run"}
									value={object.antimalware_scan}
									error={object.antimalware_scan_error}
									property={properties.antimalware_scan}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Is Task Scheduler clean?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.scheduler_clean}
											error={object.scheduler_clean_error}
											property={properties.scheduler_clean}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Is Auto run Startup clean?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.startup_clean}
											error={object.startup_clean_error}
											property={properties.startup_clean}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label"> Extensions Clean</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch

											value={object.extensions_clean}
											error={object.extensions_clean_error}
											property={properties.extensions_clean}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>

								</div>

							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"SFC Results"}
									value={object.sfc_results}
									error={object.sfc_results_error}
									property={properties.sfc_results}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Chkdsk Results"}
									value={object.chkdsk_results}
									error={object.chkdsk_results_error}
									property={properties.chkdsk_results}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Ipconfig / flushdns take?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.ipconfig_flushdns}
											error={object.ipconfig_flushdns_error}
											property={properties.ipconfig_flushdns}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>

						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Software Survey</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Office Suite Version"}
									value={object.office_version}
									error={object.office_version_error}
									property={properties.office_version}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-6"}>
										<span className="input-label">Did you record serial key in C:\KTI(date)?</span>
									</div>
									<div className={"col-6 text-right"}>
										<Framework.Elements.ButtonSwitch
											value={object.record_serial_key}
											error={object.record_serial_key_error}
											property={properties.record_serial_key}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={"Yes"}
											labelFalse={"No"}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"QuickBooks Version"}
									value={object.qb_version}
									error={object.qb_version_error}
									property={properties.qb_version}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"QuickBooks Host or Client"}
									value={object.qb_host_client}
									error={object.qb_host_client_error}
									property={properties.qb_host_client}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"List Other Important Software"}
									value={object.other_software}
									error={object.other_software_error}
									property={properties.other_software}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"What is the Other Software's Function"}
									value={object.other_software_function}
									error={object.other_software_function_error}
									property={properties.other_software_function}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title">System Survey </h4>
							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"System Make / Model (or MB if custom)"}
											value={object.system_model}
											error={object.system_model_error}
											property={properties.system_model}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Operating System"}
											value={object.os}
											error={object.os_error}
											property={properties.os}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"32bit or 64bit?"}
											value={object.system_bit}
											error={object.system_bit_error}
											property={properties.system_bit}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Original OS (is Key Visible?)"}
											value={object.original_os}
											error={object.original_os_error}
											property={properties.original_os}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<div className={"row"}>
											<div className={"col-6"}>
												<span className="input-label">OS up to Date</span>
											</div>
											<div className={"col-6 text-right"}>
												<Framework.Elements.ButtonSwitch
													value={object.os_up_to_date}
													error={object.os_up_to_date_error}
													property={properties.os_up_to_date}
													update={this.handleTextFieldPropertyUpdate}
													labelTrue={"Yes"}
													labelFalse={"No"}
												/>
											</div>
										</div>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"CPU"}
											value={object.cpu}
											error={object.cpu_error}
											property={properties.cpu}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"RAM"}
											value={object.ram}
											error={object.ram_error}
											property={properties.ram}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Ram Slots Used"}
											value={object.ram_slots_used}
											error={object.ram_slots_used_error}
											property={properties.ram_slots_used}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"RAM Slots Total"}
											value={object.ram_slots_total}
											error={object.ram_slots_total_error}
											property={properties.ram_slots_total}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Ip Address"}
											value={object.ip_address}
											error={object.ip_address_error}
											property={properties.ip_address}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Ip Address Static or Dynamic"}
											value={object.ip_static_dynamic}
											error={object.ip_static_dynamic_error}
											property={properties.ip_static_dynamic}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"DNS"}
											value={object.dns}
											error={object.dns_error}
											property={properties.dns}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Perferred Browser"}
											value={object.preferred_browser}
											error={object.preferred_browser_error}
											property={properties.preferred_browser}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"All Third Party Plugins"}
											value={object.third_party_plugins}
											error={object.third_party_plugins_error}
											property={properties.third_party_plugins}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>



						</div>
					</div>
					<div className={"row"}>
						<div className={"col-lg"}>
							<h4 className="section-title">Notes </h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Notes"}
									value={object.other_notes}
									error={object.other_notes_error}
									property={properties.other_notes}
									update={this.handleTextFieldPropertyUpdate}
									multiline={true}
								/>
							</div>
						</div>


					</div>





					</fieldset>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</div>
		)
	}
}

